import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { EnvironmentService } from '@indutrust/shared-env';
import type { Country } from '@indutrust/shared-model';
import { BaseApiClient } from '@indutrust/shared-model';

@Service()
export class CountryApiClient extends BaseApiClient<Country> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/countries`;
  }
}
